export const env = {
  // Environment specific variables
  reactAppStage: process.env.REACT_APP_STAGE,
  openIdConnectUrl: process.env.REACT_APP_OPEN_ID_CONNECT_URL,
  redirectUri: process.env.REACT_APP_REDIRECT_URI,
  audience: process.env.REACT_APP_AUDIENCE,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  pingGroup: process.env.REACT_APP_PING_GROUP,
  scope: process.env.REACT_APP_SCOPE,
  clientId: process.env.REACT_APP_CLIENT_ID,
  clientSecret: process.env.REACT_APP_CLIENT_SECRET,
};

export default env;
